import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BannerCommon } from '../../helperComponents/BannerCommon';
import { jsx as _jsx } from "react/jsx-runtime";
var IMAGE_SIZE = [303, 208];
var getGapValue = function getGapValue(layouType) {
  return layouType === 'tablet' ? 32 : 24;
};
export function BannerSecondary(props) {
  return /*#__PURE__*/_jsx(BannerCommon, _objectSpread({
    topSlot: null,
    sizes: {
      image: IMAGE_SIZE,
      mainGap: getGapValue(props.layoutType)
    }
  }, props));
}